import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TopbarService } from '../../core/services/topbar.service';
import { TranslateModule } from '@ngx-translate/core';
import { SidebarComponent } from '../../shared/components/sidebar/sidebar.component';
import { LoadingComponent } from '../../shared/components/loading/loading.component';
import { LanguageService } from '../../core/services/language.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-dashboard-layout',
  imports: [
    TranslateModule,
    RouterModule,
    CommonModule,
    SidebarComponent,
    LoadingComponent,
  ],
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss',
})
export class DashboardLayoutComponent implements OnInit, OnDestroy {
  topbarService = inject(TopbarService);
  languageService = inject(LanguageService);
  isSidebarOpen: boolean = false;
  isBurgerAnimating = false;
  loading$ = this.languageService.loading$;
  isMobile = false;
  rtlSub!: Subscription;
  rtl: boolean = true;   
  constructor() {}
  ngOnInit() {
    this.checkIfMobile();
    window.addEventListener('resize', this.checkIfMobile.bind(this));
   this.rtlSub = this.languageService.rtl$.subscribe((isRtl) => {
    this.rtl = isRtl;         
  });
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth <= 1024;
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.checkIfMobile.bind(this));
    this.rtlSub.unsubscribe();
  }
  closeSidebar() {
    if (this.isSidebarOpen) {
      this.isSidebarOpen = false;
      console.log('Sidebar closed');
    }
  }
  openSidebar() {
    this.isBurgerAnimating = true;
    this.isSidebarOpen = true;

    setTimeout(() => {
      this.isBurgerAnimating = false;
    }, 300);
  }
}
